module.exports = __webpack_public_path__ + "img/img38.351b49c1.svg";